/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateFeedDataSchema = z.object({
	imageId: z.string().uuid().nullable().optional(),
	campaignId: z.string().uuid(),
	title: z.string().nullable().optional(),
	subtitle: z.string().nullable().optional(),
	button: z.string(),
	location: z.string(),
	metaTitle: z.string(),
	metaDescription: z.string(),
	metaCallToAction: z.string(),
	metaPrimaryText: z.string(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
})

export type UpdateFeedDataSchema = z.infer<typeof updateFeedDataSchema>
